import { createBrowserRouter } from 'react-router'
import { routes } from './Routes'

export const router = createBrowserRouter(routes)
